import { defineNuxtPlugin } from '#app/nuxt'
import { LazyInlineAccordion, LazyInlineCheckbox, LazyInlineCitation, LazyInlineHeadingIcon, LazyInlineImageLink, LazyInlineImageLockup, LazyInlineNewsletterCta, LazyInlineRelatedContent, LazyInlineVideo, LazyRichTextBold, LazyRichTextHeading, LazyRichTextImage, LazyRichTextItalic, LazyCtaCard, LazyAudiencesCard, LazyAudiencesList, LazyAuthorCard, LazyEventsCard, LazyEventsFilterBar, LazyEventsList, LazyFeaturedTopicsCard, LazyFeaturedTopicsList, LazyFilterByAudiences, LazyFilterByResourceType, LazyFilterByServiceType, LazyFilterByStates, LazyFilterByTopics, LazyFormContacts, LazyFormMediaEnquiries, LazyFormkitMultiSelect, LazyFormkitSingleSelect, LazyGlossaryList, LazyGlossaryTerm, LazyNewsCard, LazyNewsFilterBar, LazyNewsList, LazyPodcastSeriesCard, LazyPodcastSeriesList, LazyRealStoriesCard, LazyRealStoriesList, LazyRelatedCard, LazyRelatedList, LazyResourcesCard, LazyResourcesFilterBar, LazyResourcesList, LazyServiceProvidersCard, LazyServiceProvidersFilterBar, LazyServiceProvidersList, LazyPageIntro, LazyArticleIntro, LazyBlockAdvice, LazyBlockAuthorContent, LazyBlockAuthorList, LazyBlockBenefitList, LazyBlockButton, LazyBlockCards, LazyBlockColumn, LazyBlockColumns, LazyBlockCustomSection, LazyBlockDownloadsList, LazyBlockFeature, LazyBlockForm, LazyBlockMailchimpForm, LazyBlockPhone, LazyBlockPromoBanner, LazyBlockResourceCard, LazyBlockResourceCardList, LazyBlockRichText, LazyBlockRichTextSimple, LazyBlockSearch, LazyBlockVideo, LazyBlockCampaignHeader, LazyBlockCampaignQuickLink, LazyBlockCampaignQuickLinks, LazyBlockContentCard, LazyBlockContentCardList, LazyBlockContentSecondaryCard, LazyBlockContentSecondaryCardList, LazyBlockFilteredServiceProvidersLink, LazyBlockFilteredServiceProvidersLinkList, LazyPageBanner, LazyBlockSelfAssessment, LazyBlockToolGetHelp, LazyBlockToolQuickAccess, LazyBlockToolQuickLink, LazyBlockToolQuickLinks, LazyBlockToolServiceProviders, LazyAudiencePage, LazyContentTypeAuthor, LazyContentTypeSelfAssessment, LazyEvents, LazyFeaturedTopicPage, LazyGlossaryPage, LazyLandingPage, LazyListPage, LazyListSearchPage, LazyNews, LazyPage, LazyQuickAccessResultsPage, LazyRealStories, LazyResource, LazySearch, LazyServiceProviders, LazyTestPage, LazyCustomCard, LazyNavigationElementSearchForm, LazyNavigationMenuChild, LazyNavigationMenuItem, LazyNavigationMenuMobileItem, LazyNavigationMenuMobileWrapper, LazyNavigationMenuWrapper, LazyNavigationSecondaryTabMenu, LazyNavigationSecondaryTabSearch, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["InlineAccordion", LazyInlineAccordion],
["InlineCheckbox", LazyInlineCheckbox],
["InlineCitation", LazyInlineCitation],
["InlineHeadingIcon", LazyInlineHeadingIcon],
["InlineImageLink", LazyInlineImageLink],
["InlineImageLockup", LazyInlineImageLockup],
["InlineNewsletterCta", LazyInlineNewsletterCta],
["InlineRelatedContent", LazyInlineRelatedContent],
["InlineVideo", LazyInlineVideo],
["RichTextBold", LazyRichTextBold],
["RichTextHeading", LazyRichTextHeading],
["RichTextImage", LazyRichTextImage],
["RichTextItalic", LazyRichTextItalic],
["CtaCard", LazyCtaCard],
["AudiencesCard", LazyAudiencesCard],
["AudiencesList", LazyAudiencesList],
["AuthorCard", LazyAuthorCard],
["EventsCard", LazyEventsCard],
["EventsFilterBar", LazyEventsFilterBar],
["EventsList", LazyEventsList],
["FeaturedTopicsCard", LazyFeaturedTopicsCard],
["FeaturedTopicsList", LazyFeaturedTopicsList],
["FilterByAudiences", LazyFilterByAudiences],
["FilterByResourceType", LazyFilterByResourceType],
["FilterByServiceType", LazyFilterByServiceType],
["FilterByStates", LazyFilterByStates],
["FilterByTopics", LazyFilterByTopics],
["FormContacts", LazyFormContacts],
["FormMediaEnquiries", LazyFormMediaEnquiries],
["FormkitMultiSelect", LazyFormkitMultiSelect],
["FormkitSingleSelect", LazyFormkitSingleSelect],
["GlossaryList", LazyGlossaryList],
["GlossaryTerm", LazyGlossaryTerm],
["NewsCard", LazyNewsCard],
["NewsFilterBar", LazyNewsFilterBar],
["NewsList", LazyNewsList],
["PodcastSeriesCard", LazyPodcastSeriesCard],
["PodcastSeriesList", LazyPodcastSeriesList],
["RealStoriesCard", LazyRealStoriesCard],
["RealStoriesList", LazyRealStoriesList],
["RelatedCard", LazyRelatedCard],
["RelatedList", LazyRelatedList],
["ResourcesCard", LazyResourcesCard],
["ResourcesFilterBar", LazyResourcesFilterBar],
["ResourcesList", LazyResourcesList],
["ServiceProvidersCard", LazyServiceProvidersCard],
["ServiceProvidersFilterBar", LazyServiceProvidersFilterBar],
["ServiceProvidersList", LazyServiceProvidersList],
["PageIntro", LazyPageIntro],
["ArticleIntro", LazyArticleIntro],
["BlockAdvice", LazyBlockAdvice],
["BlockAuthorContent", LazyBlockAuthorContent],
["BlockAuthorList", LazyBlockAuthorList],
["BlockBenefitList", LazyBlockBenefitList],
["BlockButton", LazyBlockButton],
["BlockCards", LazyBlockCards],
["BlockColumn", LazyBlockColumn],
["BlockColumns", LazyBlockColumns],
["BlockCustomSection", LazyBlockCustomSection],
["BlockDownloadsList", LazyBlockDownloadsList],
["BlockFeature", LazyBlockFeature],
["BlockForm", LazyBlockForm],
["BlockMailchimpForm", LazyBlockMailchimpForm],
["BlockPhone", LazyBlockPhone],
["BlockPromoBanner", LazyBlockPromoBanner],
["BlockResourceCard", LazyBlockResourceCard],
["BlockResourceCardList", LazyBlockResourceCardList],
["BlockRichText", LazyBlockRichText],
["BlockRichTextSimple", LazyBlockRichTextSimple],
["BlockSearch", LazyBlockSearch],
["BlockVideo", LazyBlockVideo],
["BlockCampaignHeader", LazyBlockCampaignHeader],
["BlockCampaignQuickLink", LazyBlockCampaignQuickLink],
["BlockCampaignQuickLinks", LazyBlockCampaignQuickLinks],
["BlockContentCard", LazyBlockContentCard],
["BlockContentCardList", LazyBlockContentCardList],
["BlockContentSecondaryCard", LazyBlockContentSecondaryCard],
["BlockContentSecondaryCardList", LazyBlockContentSecondaryCardList],
["BlockFilteredServiceProvidersLink", LazyBlockFilteredServiceProvidersLink],
["BlockFilteredServiceProvidersLinkList", LazyBlockFilteredServiceProvidersLinkList],
["PageBanner", LazyPageBanner],
["BlockSelfAssessment", LazyBlockSelfAssessment],
["BlockToolGetHelp", LazyBlockToolGetHelp],
["BlockToolQuickAccess", LazyBlockToolQuickAccess],
["BlockToolQuickLink", LazyBlockToolQuickLink],
["BlockToolQuickLinks", LazyBlockToolQuickLinks],
["BlockToolServiceProviders", LazyBlockToolServiceProviders],
["AudiencePage", LazyAudiencePage],
["ContentTypeAuthor", LazyContentTypeAuthor],
["ContentTypeSelfAssessment", LazyContentTypeSelfAssessment],
["Events", LazyEvents],
["FeaturedTopicPage", LazyFeaturedTopicPage],
["GlossaryPage", LazyGlossaryPage],
["LandingPage", LazyLandingPage],
["ListPage", LazyListPage],
["ListSearchPage", LazyListSearchPage],
["News", LazyNews],
["Page", LazyPage],
["QuickAccessResultsPage", LazyQuickAccessResultsPage],
["RealStories", LazyRealStories],
["Resource", LazyResource],
["Search", LazySearch],
["ServiceProviders", LazyServiceProviders],
["TestPage", LazyTestPage],
["CustomCard", LazyCustomCard],
["NavigationElementSearchForm", LazyNavigationElementSearchForm],
["NavigationMenuChild", LazyNavigationMenuChild],
["NavigationMenuItem", LazyNavigationMenuItem],
["NavigationMenuMobileItem", LazyNavigationMenuMobileItem],
["NavigationMenuMobileWrapper", LazyNavigationMenuMobileWrapper],
["NavigationMenuWrapper", LazyNavigationMenuWrapper],
["NavigationSecondaryTabMenu", LazyNavigationSecondaryTabMenu],
["NavigationSecondaryTabSearch", LazyNavigationSecondaryTabSearch],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
